<template>

 <div class="background">
        <div class="shape"></div>
    </div>
    <form @submit.prevent="login">
        <h3>Zde se přihlaste</h3>

        <label for="username">Přezdívka</label>
        <input type="text" v-model="username" placeholder="Přezdívka">

        <label for="password">Heslo</label>
        <input type="password" v-model="password" placeholder="Heslo">

        <button type="submit">Přihlásit do účtu</button>
        <div class="additional">
        <p> Nemáte účet? Registrujte se </p>
        <router-link to="/register">Registrovat se</router-link>

        <p class="errorMessage" v-if="status == 0">{{message}}</p>
        </div>
    </form>

</template>



<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      status: -5,
      message: ""
    };
  },
  methods: {
    async login() {
      console.log("ahoj");
      const { username, password } = this;
      const formData = new FormData();
      formData.append('name', username);
      formData.append('password', password);

      const res = await fetch(
        "http://owe.banicevic.eu/?action=login",
        {
          method: "POST",
          body: formData
        }
      );
      const data = await res.json();
      if(data.code == 1){
          window.localStorage.setItem("code", data.result.code);
          window.localStorage.setItem("name", username);
          window.localStorage.setItem("IDusers", data.result.IDusers);
          this.$router.push("/talker");
      } else {
        this.message = data.message;
        this.status = data.code;
      }
      console.log(data);
    },
  },
};
</script>

<style lang="scss" scoped>

      *,
*:before,
*:after{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
body{
    background-color: #080710;
}
.background{
    width: 430px;
    height: 530px;
    position: absolute;
    transform: translate(-50%,-50%);
    left: 50%;
    top: 50%;
}
.background .shape{
    height: 30px;
    width: 30px;
    position: absolute;
    border-radius: 50%;
}
.shape:first-child{
    background: linear-gradient(
        red,
        orange
    );
     left: 3px;
    top: -8px;
}

form{
    height: 520px;
    width: 400px;
    background-color: rgba(23,105,255,0.7);
    position: absolute;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
    border-radius: 10px;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255,255,255,0.1);
    box-shadow: 0 0 40px rgba(8,7,16,0.6);
    padding: 50px 35px;
}
form *{
    font-family: 'Poppins',sans-serif;
    color: #ffffff;
    letter-spacing: 0.5px;
    outline: none;
    border: none;
}
form h3{
    font-size: 32px;
    font-weight: 500;
    line-height: 42px;
    text-align: center;
}

label{
    display: block;
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
}
input{
    display: block;
    height: 50px;
    width: 100%;
    background-color: rgba(255,255,255,0.07);
    border-radius: 3px;
    padding: 0 10px;
    margin-top: 8px;
    font-size: 14px;
    font-weight: 300;
}
::placeholder{
    color: #e5e5e5;
}
button{
    margin-top: 50px;
    width: 100%;
    background-color: #ffffff;
    color: #080710;
    padding: 15px 0;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    cursor: pointer;
}
.additional{
  margin-top:20px;
}

.errorMessage{
  color: #ed0000;
    text-shadow: 0px 2px 6px red;
}
</style>